var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2703 0.00711002C19.7881 -0.417907 0.432127 18.2652 0.00711002 41.7297C-0.417907 65.1942 18.2652 84.5679 41.7297 84.9929C65.1942 85.4179 84.5679 66.7348 84.9929 43.2526C85.4179 19.7881 66.7348 0.414418 43.2703 0.00711002ZM41.8713 77.0238C22.8341 76.6696 7.62201 60.9086 7.97619 41.8713C8.31266 22.8341 24.0737 7.62201 43.111 7.95848C62.1659 8.31266 77.3603 24.0737 77.0238 43.111C76.6873 62.1482 60.9086 77.3603 41.8713 77.0238Z",
    fill: "#FF782C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0578 11.5003C25.9686 11.1992 11.8191 24.8529 11.518 41.9422C11.4171 47.3186 12.708 52.4029 15.0492 56.8585H24.7909V26.3529C24.7909 24.4881 27.3251 23.8949 28.1486 25.5684L42.5 54.6307L56.8514 25.5701C57.6749 23.8949 60.2091 24.4881 60.2091 26.3529V56.8585H69.9207C72.0989 52.7181 73.3952 48.0429 73.482 43.0578C73.7831 25.9686 60.1471 11.8191 43.0578 11.5003Z",
    fill: "#FF782C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6672 58.6294V33.9394L44.0867 59.4139C43.4917 60.6234 41.5065 60.6234 40.9115 59.4139L28.3328 33.9394V58.6294C28.3328 59.607 27.5412 60.4003 26.5618 60.4003H17.2628C22.7721 68.141 31.7293 73.2907 41.9422 73.482C52.5623 73.6697 62.0402 68.4633 67.7726 60.4003H58.4381C57.4588 60.4003 56.6672 59.607 56.6672 58.6294Z",
    fill: "#FF782C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonero);
export default __webpack_public_path__ + "static/media/monero.b32d9794ddbe8e10ae86490ba72594c2.svg";
export { ForwardRef as ReactComponent };